export default {"src":"/_next/static/media/ShoImage.517fb537.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};